import React, { useState, useEffect } from 'react';
import moment from 'moment';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { abusingIpReportClick } from 'lib/api/abusing';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const Statistics = ({ location }) => {
  // 통계보고서 - 어뷰징관리 - 클릭 ip, type, sDate, eDate, isPop
  const { t } = useTranslation();

  const [initialization, setInitialization] = useState(false);

  let initParam = {
    sort: 'asc',
    order: 'CLICK_DTTM',
    sDate: moment().add(-1, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    type: 'click',
  };
  const { eDate, sDate, type, ip } = queryString.parse(location.search);

  if (typeof eDate !== 'undefined') {
    initParam = {
      ...initParam,
      eDate: eDate,
    };
  }
  if (typeof sDate !== 'undefined') {
    initParam = {
      ...initParam,
      sDate: sDate,
    };
  }
  if (typeof type !== 'undefined') {
    initParam = {
      ...initParam,
      type: type,
    };
  }
  if (typeof ip !== 'undefined') {
    initParam = {
      ...initParam,
      ip: ip,
    };
  }

  const [params, setParams] = useState(initParam);

  const initList = {
    type: [
      { label: '총클릭', value: 'click' },
      { label: '유효클릭', value: 'avalClick' },
      { label: '무효클릭', value: 'ivdClick' },
    ],
  };
  const [list] = useState(initList);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
        <FilterCollection
          label={t('타입')}
          name="type"
          params={params}
          value={params.type}
          type="select"
          list={list.type}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={abusingIpReportClick}
        useTotal={false}
        useFetch={false}
        rowsPerPage={-1}
        usePagenation={false}
      />
    </>
  );
};

export default withRouter(Statistics);
